import {CalendarDays, Download, MapPin, Share} from "lucide-react";
import {FC, useRef, useState} from "react";
import {formatWithThousandsSeparator} from "../utils/currency.ts";
import {QRCodeSVG} from 'qrcode.react';
import {formatDateToFrench, getHourFromDate} from "../utils/dateUtils.ts";
import DashedSeparator from "./DashedSeparator.tsx";
import dayjs from "dayjs";
import html2canvas from "html2canvas";
import ShareEventTicketModal from "./ShareEventTicketModal.tsx";

interface Props {
    ticket: any;
    currentIndex: number;
    totalTickets: number;
}

const Ticket: FC<Props> = ({ticket, totalTickets, currentIndex}) => {
    const [isOpenShareModal, setIsOpenShareModal] = useState(false);

    const divRef = useRef(null);
    const buttonRef = useRef(null);

    const captureImage = async () => {
        if (divRef.current && buttonRef.current) {
            // Cacher le bouton avant la capture
            // @ts-ignore
            buttonRef.current.style.display = "none";

            // Capturer l'image
            const canvas = await html2canvas(divRef?.current, {
                useCORS: true,
            });

            const image = canvas.toDataURL("image/png");

            // Réafficher le bouton après la capture
            // @ts-ignore
            if (buttonRef.current) {
                // @ts-ignore
                buttonRef.current.style.display = "flex";
            }

            // Télécharger l'image
            const link = document.createElement("a");
            link.href = image;
            link.download = `Ticket_${ticket?.code}.png`;
            link.click();
        }
    };

    const image = ticket?.service?.events?.title === 'TOGO VS MAURITANIE' && '/branding/ftf/TOGOVSMAURITANIE.jpg'

    return (
        <>
            <div ref={divRef}
                 className='min-w-full flex flex-col shadow-xl bg-white rounded-xl items-center justify-center mr-2'>
                <div className=" w-full h-40 flex items-center justify-center ">
                    <img

                        src={image || "https://placehold.jp/150x150.png"}
                        /*
                                            src={ticket?.service?.events?.eventImage || "https://placehold.jp/150x150.png"}
                        */
                        className="w-full h-full object-cover rounded-tl-lg rounded-tr-lg"
                        alt="Events image"
                    />
                </div>
                <div className='py-2 px-4 w-full'>
                    <div
                        className="text-xl break-words whitespace-normal text-black text-center my-2 font-bold">
                        {ticket?.service?.events?.title}
                    </div>
                    <div className='flex gap-1 justify-center items-center text-base'><CalendarDays
                        size={18}/> {formatDateToFrench(ticket?.service?.events?.eventDate)} · {dayjs(ticket?.service?.events?.eventDate).format('HH:mm')}
                    </div>
                    <div className='flex gap-1 justify-center items-center text-base mb-2'><MapPin
                        size={18}/> {ticket?.service?.events?.eventPlace}</div>
                    <DashedSeparator className='my-2'/>
                    <p className="flex justify-center items-center text-base text-[#999999]">Ticket {currentIndex + 1}/{totalTickets}</p>
                    <DashedSeparator className='my-2'/>
                    <p className='flex justify-center items-center text-xs text-[#999999] mt-4'>{ticket?.service?.name}</p>
                    <p className='flex justify-center items-center text-xs text-[#999999] mt-4'>Créer
                        le {formatDateToFrench(ticket?.createdAt)} · {getHourFromDate(ticket?.createdAt)}</p>
                    <p className='flex justify-center items-center text-2xl font-bold text-third'>{ticket?.amount === 0 ? 'Gratuit' : formatWithThousandsSeparator(ticket?.amount)} {ticket?.amount > 0 && ticket?.currency}</p>
                    <div className="flex flex-col gap-2 items-center justify-center my-4">
                        <QRCodeSVG height={185} width={185} value={ticket?.codeV2}/>
                        {ticket?.state === 2 &&
                            <p className='bg-red-600 text-white p-2 py-1 rounded-lg'>Déjà scanné</p>}
                    </div>
                    {/* <div className="flex flex-col items-center justify-center gap-2">
                    <div className="flex items-center justify-center gap-4">
                        <img className="size-12 object-contain" src="/sponsors/Logo%20YAS.png" alt=""/>
                        <img className="size-12 object-contain" src="/sponsors/Voltic%20logo.png" alt=""/>
                    </div>
                    <p>Sponsors officiel</p>
                </div>*/}
                    <div ref={buttonRef} className="flex gap-4 items-center justify-center">
                        <button onClick={() => {
                            captureImage()
                            /* navigate('/download', {
                                 state: {ticket, currentIndex, totalTickets}
                             })*/
                        }}
                                className="border border-black self-center mt-4 text-black bg-white rounded-full py-2 px-4 flex items-center justify-center gap-2 shadow">
                            <Download/>
                            <p>Télécharger</p>
                        </button>
                        <button onClick={() => setIsOpenShareModal(true)}
                                className="border border-black self-center mt-4 text-black bg-white rounded-full py-2 px-4 flex items-center justify-center gap-2 shadow">
                            <Share/>
                            <p>Partager</p>
                        </button>
                    </div>
                </div>
            </div>
            <ShareEventTicketModal
                ticket={ticket}
                visible={isOpenShareModal}
                onClose={() => {
                    console.log("setIsOpenShareModal")
                    setIsOpenShareModal(false);
                }}
            />
        </>
    );
};

export default Ticket;
